import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';

export const CommunityCenterIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    fill: props.fill || '#43494F',
    width: props.width || '21',
    height: props.height || '21',
  };
  return (
    <svg viewBox='0 0 21 21' xmlns='http://www.w3.org/2000/svg' {...svgProps}>
      <g clipPath='url(#clip0_13190_22741)'>
        <path
          d='M12.9929 11.1536L8.22587 7.42175C7.50488 6.85738 6.496 6.8565 5.775 7.42175L1.00713 11.1528C0.3675 11.6541 0 12.4084 0 13.2204V21H14V13.2204C14 12.4075 13.6325 11.6541 12.9929 11.1536ZM12.25 19.25H1.75V13.2204C1.75 12.9491 1.8725 12.698 2.086 12.5309L6.853 8.80075C6.93875 8.7325 7.0595 8.73337 7.147 8.80075L11.914 12.5326C12.1275 12.6989 12.25 12.9509 12.25 13.2212V19.25ZM5.25 13.125H8.75V16.625H5.25V13.125ZM15.75 11.375H17.5V13.125H15.75V11.375ZM15.75 14.875H17.5V16.625H15.75V14.875ZM12.25 4.375H14V6.125H12.25V4.375ZM17.5 6.125H15.75V4.375H17.5V6.125ZM12.25 7.875H14V9.625H12.25V7.875ZM15.75 7.875H17.5V9.625H15.75V7.875ZM21 2.625V21H15.75V19.25H19.25V2.625C19.25 2.142 18.858 1.75 18.375 1.75H11.375C10.892 1.75 10.5 2.142 10.5 2.625V6.98075L8.75 5.61137V2.625C8.75 2.61013 8.75 2.59437 8.75088 2.5795C8.77538 1.15325 9.94263 0 11.375 0H18.375C19.8223 0 21 1.17775 21 2.625Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};
CommunityCenterIcon.iconType = ICON_TYPES.COMMUNITY_CENTER_ICON;
